export { default as BlogPostsListQuery } from './BlogPostsListQuery';